import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { environment } from "environments/environment";
import { Bind } from "primeng/bind";
import { FileUpload } from "primeng/fileupload";

@Component({
  selector: "app-upload",
  templateUrl: "./upload.component.html",
  styleUrls: ["./upload.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, FileUpload],
})
export class UploadComponent {
  public readonly fileUploaded = output<string>();
  public readonly label = input("Choose file");
  public readonly multiple = input(false);
  public readonly outlined = input(false);
  public readonly showUploadedFile = input(false);
  public uploadPath = `${environment.apiUrl}/upload`;
  public uploadedfileName: string = null;
  public uploadedFileUrl: string = null;
  public loading = false;

  public onBeforeUpload() {
    this.loading = true;
  }

  public onUploadResponse(event) {
    const response = event.originalEvent.body;
    this.uploadedfileName = response.fileName;
    this.uploadedFileUrl = response.url;
    this.fileUploaded.emit(response.url);
    this.loading = false;
  }
}
